import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { uploadFiles } from "@/lib/api";

export const ImportXmlButton = ({ onImported, variant = "outline", size = "default", className = "" }) => {
  const fileRef = useRef(null);
  const [importing, setImporting] = useState(false);

  const onFiles = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setImporting(true);
    try {
      const res = await uploadFiles("/transactions/import-xml", files);
      const parts = [];
      if (res.created_uscite) parts.push(`${res.created_uscite} ricevute`);
      if (res.created_entrate) parts.push(`${res.created_entrate} emesse`);
      if (res.created > 0) toast.success(`Importate ${parts.join(" · ")}.`);
      else toast.info("Nessuna nuova fattura importata.");
      if (res.skipped > 0) toast.info(`${res.skipped} già presenti o non valide, saltate.`);
      if (!res.company_piva_set) toast.warning("P.IVA azienda non impostata: fatture importate come ricevute. Impostala in Impostazioni per lo smistamento automatico.");
      (res.errors || []).forEach((msg) => toast.error(msg));
      onImported?.(res);
    } catch (err) {
      toast.error(err.message || "Import non riuscito.");
    } finally {
      setImporting(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={fileRef} type="file" accept=".xml,.p7m,.zip" multiple className="hidden" onChange={onFiles} data-testid="import-xml-input" />
      <Button variant={variant} size={size} onClick={() => fileRef.current?.click()} disabled={importing} data-testid="import-xml-button" className={`gap-2 ${className}`}>
        {importing ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        <span className="hidden sm:inline">Importa XML</span>
      </Button>
    </>
  );
};
